'use client';
/* eslint-disable tailwindcss/no-arbitrary-value */
import { CmsImage } from '@hyphengroup/cms-components/components/CmsImage';
import { WrappedText } from '../components-internal/WrappedText';
import { tr } from '../helpers';
import { ComponentHeroCampaingFeature } from '$/(cms)/_modules/cmsService/types';
import { useClientContext } from '$/modules/context/client';

export const HeroCampaingFeature: React.FC<ComponentHeroCampaingFeature> = ({
  title,
  subtitle,
  image,
  alt_image,
}) => {
  const { lang } = useClientContext();

  return (
    <div className="flex w-full max-w-page-max gap-spacing/padding/x-sm rounded-radius/button border border-borders/default p-spacing/gap/soft-12px bg-fill/card">
      <div className="flex size-20 shrink-0 items-center justify-center">
        <CmsImage
          alt={alt_image ?? ''}
          src={image?.url ?? ''}
          width={80}
          height={80}
          sizes={{ _: 80 }}
          className="size-full rounded-radius/button object-contain object-center"
        />
      </div>
      <div className="flex flex-col gap-spacing/gap/soft-4px text-text/primary">
        <div className="alpha-title-2">{title}</div>

        {subtitle && (
          <div className="mhg-alpha-body-2-relaxed text-left">
            <WrappedText
              showMoreButtonVisible={true}
              showMoreButtonText={tr('show_more', lang).toLowerCase()}
            >
              {subtitle}
            </WrappedText>
          </div>
        )}
      </div>
    </div>
  );
};
